import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevyAutoSpinCountControlFactory } from "./factories/gamevy-auto-spin-count-control-factory";
import { GamevyAutoSpinStartControlFactory } from "./factories/gamevy-auto-spin-start-control-factory";
import { GamevyAutoSpinStopControlFactory } from "./factories/gamevy-auto-spin-stop-control-factory";
import { GamevyDontShowControlFactory } from "./factories/gamevy-dont-show-control-factory";
import { GamevySpeedControlFactory } from "./factories/gamevy-speed-control-factory";
import { GamevyTotalStakeStepperControlFactory } from "./factories/gamevy-total-stake-stepper-control-factory";

export function GetGamevyControlFactories(): ControlFactory[] {
    return [
        new GamevyTotalStakeStepperControlFactory(),
        new GamevySpeedControlFactory(),
        new GamevyAutoSpinCountControlFactory(),
        new GamevyDontShowControlFactory(),
        new GamevyAutoSpinStartControlFactory(),
        new GamevyAutoSpinStopControlFactory()
    ];
}
